import { Panel } from './Panel';
import { BatterySwitch } from '../ui';
import { LoadContext } from "../../../utils";
import { Sprite } from 'pixi.js';
import { Focusable, InteractiveWrapper } from '../../../ui';
import { Game } from '../../../game';

export class Battery extends Panel
{
    // private onButton:RadioButton;
    // private offButton:RadioButton;
    private switch: BatterySwitch;

    public static preload() {
        LoadContext.current.add('Settings', './assets/accessibility/Settings{size}.json');
        BatterySwitch.preload();
    }

    constructor( game:Game )
    {
        super(
            game,
            "Battery pack",
            {
                title: "CYB_Panel3_BatteryPack",
                explain: 'CYB_Panel3_BatteryChallenge',
                settings: 'CYB_Panel3_BatteryYesNo',
            },
            {width: 826, height: 233}
        );

        const icon:Sprite = new Sprite( LoadContext.current.getSpritesheet('Settings').textures['icon_battery'] );
        icon.position.set( this.icon_x, this.icon_y );
        this.addChild( icon );

        this.switch = new BatterySwitch();
        this.switch.position.set( 340, 135 );
        this.updateToMatchSetting();

        this.switch.on( "switchChanged", (newValue:boolean)=>{
            this.game.vo.stop();
            this.game.settings.useBattery.value = newValue;
            const eventName: string = newValue ? "battery_pack_on" : "battery_pack_off";
            this.game.logEvent("change_setting", eventName);
            this.playSwitchSelectionVO(this.switch, newValue ? 'CYB_Panel3_NoUnlimitedBatteryPack' : 'CYB_Panel3_UnlimitedBatteryPack');
        });
        this.disposables.add(new InteractiveWrapper(this.switch, {
            onHover: () => {
                this.game.vo.playHighlight(this.game.settings.useBattery.value ? 'CYB_Panel3_NoUnlimitedBatteryPack' : 'CYB_Panel3_UnlimitedBatteryPack');
            },
            onFocus: () => {
                this.game.vo.playHighlight([this.game.settings.useBattery.value ? 'CYB_Panel3_NoUnlimitedBatteryPack' : 'CYB_Panel3_UnlimitedBatteryPack', 'CYB_Panel_SettingEdit']);
            },
            onTap: () => {}
        }));
        this.addChild( this.switch );

        this.updateToMatchSetting();
    }

    getFocusItems():Focusable[]
    {
        let items = super.getFocusItems();
        return items.concat( [this.switch] );
    }

    updateToMatchSetting()
    {
        super.updateToMatchSetting();
        this.turnOn( this.settings.useBattery.value );
    }

    private turnOn( value:boolean )
    {
        this.switch.isOn = value;

        if( value != this.settings.useBattery.value ) {
            this.settings.useBattery.value = value;
        }
    }

    destroy()
    {
        super.destroy();
    }
}